import Settings from '../settings';

const debug = process.env.NODE_ENV === 'development';

export default class Clipper {
  constructor(user, sessionId, isContainer) {
    this.sessionId = sessionId;
    this.isContainer = isContainer;
    this.clipperUrl = isContainer
      ? `clipper://launch/${user}/${sessionId}`
      : `${debug ? 'http://localhost:3000/' : Settings.serverPath}#/clipper/${user}/${sessionId}`;
  }

  openClipper = () => {
    if (this.isContainer) {
      const xHttp = new XMLHttpRequest();
      xHttp.open('GET', this.clipperUrl);
      xHttp.send();
    } else {
      window.open(
        this.clipperUrl,
        '_blank',
        `height=${window.screen.availHeight - 60},width=${
          window.screen.availWidth
        },titlebar=no,location=no,status=no,toolbar=no,left=0,top=0`
      );
    }
  };
}



// WEBPACK FOOTER //
// ./app/util/clipper.js